import Flag from "@/components/Flag";

const ITEMS = [
  { name: "English", code: "us" },
  { name: "French", code: "fr" },
  { name: "Spanish", code: "es" },
  { name: "Haitian Creole", code: "ht" },
  { name: "Portuguese", code: "br" },
  { name: "Arabic", code: "sa" },
  { name: "Chinese", code: "cn" },
  { name: "Japanese", code: "jp" },
  { name: "Korean", code: "kr" },
  { name: "Wolof", code: "sn" },
  { name: "Lingala", code: "cd" },
  { name: "Yoruba", code: "ng" },
];

export default function LangTicker() {
  // Double the array so the marquee loop is seamless
  const doubled = [...ITEMS, ...ITEMS];

  return (
    <div
      data-testid="lang-ticker"
      className="relative overflow-hidden bg-[#04132F] border-y border-white/10 marquee-pause-on-hover"
    >
      <div className="flex w-max animate-marquee py-3.5">
        {doubled.map((it, i) => (
          <div
            key={`${it.name}-${i}`}
            className="flex items-center gap-2.5 px-6 text-white/80"
          >
            <Flag code={it.code} className="w-4 h-3 rounded-[2px] flex-shrink-0" />
            <span className="text-[12px] tracking-wide font-medium whitespace-nowrap">
              {it.name}
            </span>
            <span className="text-white/15 ml-6 select-none">·</span>
          </div>
        ))}
      </div>

      {/* edge fades */}
      <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#04132F] to-transparent" />
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#04132F] to-transparent" />
    </div>
  );
}
